import Landing from "./Landing";
import withPrograma from "js/hoc/withPrograma";

import { compose } from "recompose";

const enhance = compose(withPrograma);
export default enhance(Landing);
